<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="赠送原因：">
            <el-input v-model="query.configName" placeholder="请输入赠送原因" clearable size="small" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="赠送原因" prop="configName" align="center" />
        <el-table-column label="key" prop="configKey" align="center" />
        <el-table-column label="支付方式" prop="moneyType" align="center" >
          <template slot-scope="{row}">
            {{row.moneyType===1 ? '余额' :  row.moneyType===2?"零售价":row.moneyType===3?"学费":row.moneyType===4?"积分":"-"}}
          </template>
        </el-table-column>
        <el-table-column label="是否推送凭证" prop="dataType" align="center" >
          <template slot-scope="{row}">
            {{row.isSendpz ? '是' :  '否'}}
          </template>
        </el-table-column>
         <el-table-column label="赠送类型" prop="dataType" align="center" >
          <template slot-scope="{row}">
            {{row.dataType === 1 ? '账户管理(推用友)' : row.dataType === 2 ? '其他' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="是否允许修改入账流水的原因和金额" prop="dataType" align="center" >
          <template slot-scope="{row}">
            {{row.allowEdit ? '是' :  '否'}}
          </template>
        </el-table-column>
        <!--<el-table-column label="借编码" prop="lendCode" align="center" />
        <el-table-column label="贷编码" prop="loanCode" align="center" /> -->
        
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="realName" align="center" />
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleConfig(row)">配置</el-button>
            <!-- <el-button type="text" @click="handleLog(row)">日志记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <giveReason-add ref="giveReasonAdd" @created="doQueryList({})"  />
  </div>
</template>

<script>
import giveReasonAdd from './add'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    giveReasonAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
    
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysGiftAccountReasonApi.fetchList(this.query)
        .then(({data}) => {
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysgiveReasonApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGiftAccountReasonApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGiftAccountReasonApi.update(row).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.giveReasonAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.giveReasonShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.giveReasonAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=90&id=" + row.id);
    },
    handleConfig(row){
      this.$emit('handleShow', row, 2)
    }
  }
}
</script>
